module.exports = __webpack_public_path__ + "static/media/SF-5-A.5fd214ae.mp3";